import { FilterSingleCheckbox } from '../baseInputTypes/FilterSingleCheckbox'

export const CatDotCom = () => {
  return (
    <FilterSingleCheckbox
      label="CAT.com Product Technical Information"
      fieldPath="productInformation.catDotComProductTechnicalInformation"
    />
  )
}
